<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ area.id ? "Editar" : "Nova" }}
                Área
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="area.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-2 mt-2">
                      <button class="btn btn-primary" @click="openTeamModal">
                        Selecionar Equipes
                      </button>
                    </div>
                    <div
                      class="form-group col-md-2 mt-2"
                      v-show="!area.is_georeferenced"
                    >
                      <button class="btn btn-primary" @click="openCityModal">
                        Selecionar Cidades
                      </button>
                    </div>
                    <div class="col-md-3 mt-2">
                      <div class="custom-control custom-switch">
                        <input
                          autocomplete="new-password"
                          v-model="area.is_georeferenced"
                          placeholder=""
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch1"
                        />
                        <label class="custom-control-label" for="customSwitch1"
                          >É georeferenciamento?</label
                        >
                      </div>
                    </div>

                    <div
                      class="form-group col-md-6"
                      v-show="area.is_georeferenced"
                    >
                      <label for="RaioKm">
                        <span class="required">*</span> Raio em km:
                        <span id="raioKmValue">{{ ray }}</span> km
                      </label>
                      <input
                        autocomplete="new-password"
                        type="range"
                        id="RaioKm"
                        class="form-range"
                        v-model="ray"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="form-row" v-show="area.is_georeferenced">
                    <div class="form-group col-md-12">
                      <GmapMap
                        @click="mapClicked"
                        :center="center"
                        :zoom="13"
                        style="width: 100%; height: 500px"
                      >
                        <GmapMarker
                          :position="markerPosition"
                          @dragend="markerDragged"
                          draggable
                        />
                        <GmapCircle
                          :center="circleCenter"
                          :radius="ray * 1000"
                          :options="circleOptions"
                        />
                      </GmapMap>
                    </div>
                  </div>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/area" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EQUIPES -->
    <div
      class="modal fade"
      id="SelectTeams"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SelectTeamsTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Selecionar Equipes</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label>Selecione uma Equipe</label>
                <v-select
                  :options="teams"
                  :reduce="(team) => team.id"
                  :label="'name'"
                  class="vselect"
                  v-model="selectedTeam"
                  @input="addTeam"
                >
                  <template #no-options>
                    Aguarde, carregando lista de Equipes
                  </template>
                </v-select>
              </div>
            </div>

            <!-- Lista de Equipes -->
            <div
              class="row mt-2"
              style="
                border: solid #ebe9f1 1px;
                border-radius: 3px;
                max-height: 60vh;
                overflow-y: scroll;
                overflow-x: hidden;
              "
            >
              <div
                class="col-md-12 mt-1"
                style="font-size: 16px; font-weight: bold"
              >
                Equipes Selecionadas
              </div>
              <div class="col-md-12 mt-2">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Equipe</th>
                      <th class="text-center">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(team, index) in selectedTeams" :key="team">
                      <td>{{ getTeamName(team) }}</td>
                      <td class="text-center">
                        <button
                          @click="removeTeam(index)"
                          class="btn btn-crud delete"
                        >
                          <i
                            class="far fa-trash-alt"
                            data-toggle="tooltip"
                            title="Excluir"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="saveTeams">
              <i class="fas fa-save"></i> Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CIDADES -->
    <div
      class="modal fade"
      id="SelectCities"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SelectCitiesTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Selecionar Cidades</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label>Selecione uma Cidade</label>
                <v-select
                  :options="cities"
                  :reduce="(city) => city.id"
                  :label="'name'"
                  v-model="selectedCity"
                  @input="addCity"
                >
                  <template #no-options>
                    Aguarde, carregando lista de Cidades
                  </template>
                </v-select>
              </div>
            </div>

            <!-- Lista de Cidades -->
            <div
              class="row mt-2"
              style="
                border: solid #ebe9f1 1px;
                border-radius: 3px;
                max-height: 60vh;
                overflow-y: scroll;
                overflow-x: hidden;
              "
            >
              <div
                class="col-md-12 mt-1"
                style="font-size: 16px; font-weight: bold"
              >
                Cidades Selecionadas
              </div>
              <div class="col-md-12 mt-2">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Cidade</th>
                      <th class="text-center">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(city, index) in selectedCities" :key="city">
                      <td>{{ getCityName(city) }}</td>
                      <td class="text-center">
                        <button
                          @click="removeCity(index)"
                          class="btn btn-crud delete"
                        >
                          <i
                            class="far fa-trash-alt"
                            data-toggle="tooltip"
                            title="Excluir"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="saveCities">
              <i class="fas fa-save"></i> Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
// import { GmapMap, GmapMarker } from "vue2-google-maps";

export default {
  data() {
    return {
      area: {
        name: "",
        latitude: "",
        longitude: "",
        ray: "",
        is_georeferenced: 0,
      },
      cities: [],
      selectedCities: [],
      selectedCity: null,
      teams: [],
      selectedTeams: [],
      selectedTeam: null,
      center: { lat: 0, lng: 0 },
      markerPosition: null,
      latitude: null,
      longitude: null,
      circleCenter: { lat: 0, lng: 0 }, // Centro do círculo
      circleOptions: {
        fillColor: "#00FF00",
        fillOpacity: 0.3,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
      },
      ray: 0,
    };
  },
  computed: {},
  methods: {
    openTeamModal() {
      $("#SelectTeams").modal("show");
    },
    saveTeams() {
      $("#SelectTeams").modal("hide");
    },
    addTeam() {
      if (
        this.selectedTeam &&
        !this.selectedTeams.includes(this.selectedTeam)
      ) {
        this.selectedTeams.push(this.selectedTeam);
      }
      this.selectedTeam = null;
    },
    getTeamName(id) {
      const team = this.teams.find((team) => team.id === id);
      return team ? team.name : "Equipe não encontrada";
    },
    removeTeam(index) {
      this.selectedTeams.splice(index, 1);
    },
    openCityModal() {
      $("#SelectCities").modal("show");
    },
    saveCities() {
      $("#SelectCities").modal("hide");
    },
    addCity() {
      if (
        this.selectedCity &&
        !this.selectedCities.includes(this.selectedCity)
      ) {
        this.selectedCities.push(this.selectedCity);
      }
      this.selectedCity = null;
    },
    getCityName(id) {
      const city = this.cities.find((city) => city.id === id);
      return city ? city.name : "Cidade não encontrada";
    },
    removeCity(index) {
      this.selectedCities.splice(index, 1);
    },
    mapClicked(event) {
      this.markerPosition = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.latitude = event.latLng.lat();
      this.longitude = event.latLng.lng();
      this.circleCenter = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
    },
    markerDragged(event) {
      this.markerPosition = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.latitude = event.latLng.lat();
      this.longitude = event.latLng.lng();
      this.circleCenter = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "areas";
      let method = "POST";

      if (self.area.id) {
        method = "PUT";
        api += "/" + self.area.id;
      }

      self.$loading(true);

      const data = {
        name: this.area.name,
        latitude: this.latitude,
        longitude: this.longitude,
        ray: this.ray,
        id: this.area.id,
        is_georeferenced: this.area.is_georeferenced,
        city_ids: this.selectedCities,
        team_ids: this.selectedTeams,
        _method: method,
      };

      axios
        .post(api, data)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/areas");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.markerPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.area.latitude = position.coords.latitude;
          this.area.longitude = position.coords.longitude;
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;

          this.circleCenter = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.ray = 0;
        });
      } else {
        console.error("A geolocalização não é suportada por este navegador.");
      }
    },
    getArea: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "areas/" +
        id +
        "?with[]=area_cities&with[]=area_teams";

      axios
        .get(api)
        .then((response) => {
          const areaData = response.data.data[0];
          self.area = areaData;

          const latitude = parseFloat(areaData.latitude);
          const longitude = parseFloat(areaData.longitude);
          let ray = areaData.ray;
          ray = parseFloat(ray);

          if (!isNaN(latitude) && !isNaN(longitude) && !isNaN(ray)) {
            self.center = { lat: latitude, lng: longitude };
            self.markerPosition = { lat: latitude, lng: longitude };
            self.area.latitude = latitude;
            self.area.longitude = longitude;
            self.ray = ray;
            self.circleCenter = { lat: latitude, lng: longitude };
          } else {
            console.error("Coordenadas inválidas");
          }

          self.selectedCities = areaData.area_cities.map(
            (areaCity) => areaCity.city_id
          );

          self.selectedTeams = areaData.area_teams.map(
            (areaTeam) => areaTeam.team_id
          );

          self.area.is_georeferenced =
            self.area.is_georeferenced == "0" ? 0 : 1;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getCities: function () {
      const self = this;
      let api = self.$store.state.api + "cities?paginated=false&status=1";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.cities = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getTeams: function () {
      const self = this;
      let api = self.$store.state.api + "teams?paginated=false&status=1";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.teams = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCurrentLocation();
    self.getCities();
    self.getTeams();

    let id = self.$route.params.id;
    if (id) {
      self.getArea(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

[dir] .form-range {
  /* padding: 0.438rem 1rem; */
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.form-range {
  display: block;
  width: 100%;
  height: 2.714rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>